import { render } from "./ReportsTable.vue?vue&type=template&id=2be42597&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./ReportsTable.vue?vue&type=style&index=0&id=2be42597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be42597"]])

export default __exports__